import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { REVIEWS } from "@/data/content";

const FALLBACK = REVIEWS.map((r) => ({ name: r.name, rating: r.rating, text: r.text, date: r.date, photo: null }));

export function useReviews() {
  const [state, setState] = useState({
    loading: true, source: "manual", rating: 5, total: FALLBACK.length, url: "", reviews: FALLBACK,
  });

  useEffect(() => {
    let cancelled = false;
    api.get("/reviews")
      .then(({ data }) => {
        if (cancelled) return;
        const reviews = (data.reviews || []).map((r) => ({
          name: r.author || r.name || "Google User",
          rating: r.rating || 5,
          text: r.text || "",
          date: r.when || r.date || "Recently",
          photo: r.photo || null,
        })).filter((r) => r.text);
        setState({
          loading: false,
          source: data.source || "manual",
          rating: data.rating || 5,
          total: data.total || reviews.length,
          url: data.url || "",
          reviews: reviews.length ? reviews : FALLBACK,
        });
      })
      .catch(() => { if (!cancelled) setState((s) => ({ ...s, loading: false })); });
    return () => { cancelled = true; };
  }, []);

  return state;
}
